import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchStaff, deleteStaff, fetchDesignations } from "../../redux/actions/staffActions";
import Sidebar from "../../Components/Sidebar";
import { MdOutlineDeleteForever } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import EditPopup from "./EditPopup";
import DeletePopup from "../../Components/DeletePopup";
import { useNavigate } from "react-router-dom";
import { LuUserCheck } from "react-icons/lu";
import { TbLayout2, TbUsers } from "react-icons/tb";
import { fetchDepartments } from "../../redux/actions/departmentActions";
import PageComponent from "../../Components/PageComponent";

function AllStaff() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const staff = useSelector((state) => state.staff.staffMembers.data) || [];
  const departments = useSelector((state) => state.department.department.data) || [];
  const loading = useSelector((state) => state.staff.staffMembers.loading);
  const designations = useSelector((state) => state.staff.designations.data) || [];
 

  const [editingStaff, setEditingStaff] = useState(null);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  // State for filters
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedDesignation, setSelectedDesignation] = useState("");
  const [searchName, setSearchName] = useState("");

  useEffect(() => {
    dispatch(fetchStaff());
    dispatch(fetchDepartments());
    dispatch(fetchDesignations());
  }, [dispatch]);

  const handleEdit = (staff) => {
    setEditingStaff(staff);
    setIsEditOpen(true);
  };

  const handleDelete = (staff) => {
    setEditingStaff(staff);
    setIsDeleteOpen(true);
  };

  const handleConfirmDelete = () => {
    if (editingStaff) {
      dispatch(deleteStaff(editingStaff.id));
      alert(`Staff member has been deleted.`); 
      setIsDeleteOpen(false);
    }
  };

  // Filter the staff list based on selected filters
  const filteredStaff = staff.filter((staffMember) => {
    const matchesDepartment = selectedDepartment
      ? staffMember.departmentName === selectedDepartment
      : true;
    const matchesDesignation = selectedDesignation
      ? staffMember.designation === selectedDesignation
      : true;
    const matchesName = searchName
      ? staffMember.name.toLowerCase().includes(searchName.toLowerCase())
      : true;

    return matchesDepartment && matchesDesignation && matchesName;
  });

  return (
     <>
        <PageComponent>
    <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>
      <div className="flex-1 p-6 ml-64">
        <div className="flex items-center space-x-2 text-3xl text-gray-500">
          <span>Academics & International</span>
          <span>/</span>
          <span className="text-black">Department Management</span>
        </div>

        <div className="flex items-center mt-4 space-x-4">
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() => navigate("/academics&international/departmentManagement/department")}
          >
            <TbLayout2 className="mr-2" />
            Department
          </button>
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() => navigate("/academics&international/departmentManagement/leadershipMessages")}
          >
            <LuUserCheck className="mr-2" />
            Leadership Messages
          </button>
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() => navigate("/academics&international/departmentManagement/academicStaff")}
          >
            <TbUsers className="mr-2" />
            Academic Staff
          </button>
          <button
            className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
            onClick={() => navigate("/academics&international/departmentManagement/allStaff")}
          >
            <TbUsers className="mr-2" />
            All Staff
          </button>
        </div>

        {/* Filters Section */}
        <div className="p-6 mt-6 bg-white rounded-lg shadow-md">
          <h2 className="mb-4 text-xl font-semibold text-gray-700">Filter Staff Members</h2>
          <form>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label
                  className="block mb-1 text-sm font-medium text-gray-600"
                  htmlFor="department"
                >
                  Select Department
                </label>
                <select
                  id="department"
                  name="department"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                  value={selectedDepartment}
                  onChange={(e) => setSelectedDepartment(e.target.value)}
                >
                  <option value="">Select Department</option>
                  {departments.map((dept) => (
                    <option key={dept.id} value={dept.department_name}>
                      {dept.department_name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label
                  className="block mb-1 text-sm font-medium text-gray-600"
                  htmlFor="name"
                >
                  Name
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                  value={searchName}
                  onChange={(e) => setSearchName(e.target.value)}
                />
              </div>
              <div>
                <label
                  className="block mb-1 text-sm font-medium text-gray-600"
                  htmlFor="designation"
                >
                  Designation
                </label>
                <select
  id="designation"
  name="designation"
  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
  value={selectedDesignation}
  onChange={(e) => setSelectedDesignation(e.target.value)}
>
  <option value="">Select Designation</option>
  {designations.map((designationObj) => (
    <option key={designationObj.designation} value={designationObj.designation}>
      {designationObj.designation}
    </option>
  ))}
</select>

              </div>
            </div>
          </form>
        </div>

        {/* Staff List Table */}
        <div className="p-6 mt-6 bg-white rounded-lg shadow-md">
          <h2 className="mb-4 text-xl font-semibold text-gray-700">Staff List</h2>
          {loading ? (
            <p>Loading staff members...</p>
          ) : (
            <table className="w-full border border-gray-300 table-auto">
              <thead>
                <tr className="text-left text-gray-600 bg-gray-100">
                  <th className="px-4 py-2">Name</th>
                  <th className="px-4 py-2">Designation</th>
                  <th className="px-4 py-2">Department</th>
                  <th className="px-4 py-2">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredStaff.map((staffMember) => (
                  <tr key={staffMember.id} className="border-b border-gray-300">
                    <td className="px-4 py-2">{staffMember.name}</td>
                    <td className="px-4 py-2">{staffMember.designation}</td>
                    <td className="px-4 py-2">{staffMember.departmentName}</td>
                    <td className="flex items-center justify-start px-2 py-2 gap-x-2">
                    <button
                        type="button"
                        className="flex items-center py-1 text-gray-400 bg-gray-100 border border-gray-400 rounded"
                        onClick={() => handleDelete(staffMember)}
                      >
                        <MdOutlineDeleteForever className="w-4 h-4 mx-1" />
                      </button>
                      <button
                        type="button"
                        className="flex items-center py-1 border rounded text-primary-color border-primary-color bg-primary-color bg-opacity-10"
                        onClick={() => handleEdit(staffMember)}
                      >
                        <FaRegEdit className="w-4 h-4 mx-1" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Popups */}
        <EditPopup
          isOpen={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          data={editingStaff || {}}
        />
        <DeletePopup
          title="Staff Member"
          isOpen={isDeleteOpen}
          onClose={() => setIsDeleteOpen(false)}
          onConfirm={handleConfirmDelete}
          data={editingStaff?.name || ""}
        />
      </div>
    </div>
    </PageComponent>
    </>
  );
}

export default AllStaff;

